export default __webpack_public_path__ + "3daa90493924ea107d1211a469f00a7a.wav";